import React from 'react';
import type GeneralConnectType from '@atlassian/jira-spa-apps-connect-general/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyGeneralConnect = lazyForPaint<typeof GeneralConnectType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-connect", jiraSpaEntry: "async-connect" */ '@atlassian/jira-spa-apps-connect-general'
		),
	),
);

const AsyncGeneralConnect = (): React.JSX.Element => (
	<LazyPage Page={LazyGeneralConnect} pageId="connect" shouldShowSpinner />
);

export default AsyncGeneralConnect;
